import React, { useState } from 'react';
import { useApp } from '../../AppContext';

export default function AccountSettings() {
  const { changePassword, logout, showToast } = useApp();
  const [oldPwd, setOldPwd] = useState('');
  const [newPwd, setNewPwd] = useState('');
  const [confirmPwd, setConfirmPwd] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async () => {
    setError(null);
    if (!oldPwd || !newPwd || !confirmPwd) {
      setError('Compila tutti i campi.');
      return;
    }
    if (newPwd !== confirmPwd) {
      setError('Le nuove password non coincidono.');
      return;
    }
    if (newPwd.length < 8) {
      setError('La nuova password deve essere di almeno 8 caratteri.');
      return;
    }
    setSaving(true);
    try {
      await changePassword(oldPwd, newPwd, confirmPwd);
      showToast('Password aggiornata. Ti verrà richiesto un nuovo accesso.');
      setTimeout(logout, 1500);
    } catch (e: any) {
      const data = e?.data;
      let msg = e?.message || 'Errore aggiornamento password.';
      if (data && typeof data === 'object') {
        const fieldMsg = data.old_password?.[0] || data.new_password?.[0] || data.new_password_confirm?.[0];
        if (fieldMsg) msg = fieldMsg;
        else if (Array.isArray(data.new_password)) msg = data.new_password.join(' ');
      }
      setError(msg);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-xl">
      <div className="bg-forest p-6 rounded-3xl border border-sage/15 space-y-5">
        <div>
          <h3 className="font-serif text-xl">Cambio password</h3>
          <p className="text-xs text-sage mt-1">Dopo il cambio sarai automaticamente disconnesso e dovrai accedere con la nuova password.</p>
        </div>

        <div className="space-y-3">
          <Field label="Password attuale" value={oldPwd} onChange={setOldPwd} />
          <Field label="Nuova password" value={newPwd} onChange={setNewPwd} hint="Almeno 8 caratteri, diversa dalla precedente." />
          <Field label="Conferma nuova password" value={confirmPwd} onChange={setConfirmPwd} />
        </div>

        {error && <p className="text-xs text-rose-300 font-medium">{error}</p>}

        <div className="flex justify-end">
          <button
            onClick={submit}
            disabled={saving}
            className="bg-sage hover:bg-sageLight text-forestDark px-5 py-2.5 rounded-full text-xs uppercase tracking-widest font-bold smooth-transition disabled:opacity-50"
          >
            {saving ? 'Aggiornamento…' : 'Aggiorna password'}
          </button>
        </div>
      </div>
    </div>
  );
}

function Field({ label, value, onChange, hint }: { label: string; value: string; onChange: (v: string) => void; hint?: string }) {
  return (
    <div className="space-y-1">
      <label className="text-[11px] uppercase tracking-wider font-bold text-sage">{label}</label>
      <input
        type="password"
        value={value}
        onChange={e => onChange(e.target.value)}
        autoComplete="new-password"
        className="w-full bg-forestDark/55 border border-sage/20 rounded-lg px-3 py-2.5 text-sm text-cream focus:outline-none focus:border-sage"
      />
      {hint && <p className="text-[10px] text-sage/70">{hint}</p>}
    </div>
  );
}
